import { format } from "date-fns";

export const financeStatusOptions = ["all", "pending", "review", "approved"];
export const financePriorityOptions = ["low", "medium", "high"];
export const hrLifecycleStages = [
  "all",
  "sourcing",
  "interview",
  "offer",
  "pre_joining",
  "onboarding",
  "active",
  "probation",
  "confirmed",
  "review",
  "inactive",
  "exit",
  "exited",
];

export const emptyLineItem = () => ({
  employee_name: "",
  department: "",
  base_salary: 0,
  incentives: 0,
  additions: 0,
  deductions: 0,
  notes: "",
});

export const formatCurrency = (value, currency = "INR") =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
  }).format(Number(value || 0));

export const formatDateTime = (value) => {
  if (!value) return "—";
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? "—" : parsed.toLocaleString();
};

export const formatDateOnly = (value) => {
  if (!value) return "—";
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? "—" : format(parsed, "yyyy-MM-dd");
};

export const labelize = (value) =>
  String(value || "")
    .replace(/[_-]+/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());

export const badgeToneClass = (status) => {
  const normalized = String(status || "").toLowerCase();
  const map = {
    approved: "vlq-badge tone-approved",
    locked: "vlq-badge tone-locked",
    pending: "vlq-badge tone-pending",
    review: "vlq-badge tone-review",
    draft: "vlq-badge tone-draft",
    sourcing: "vlq-badge tone-info",
    interview: "vlq-badge tone-warning",
    offer: "vlq-badge tone-gold",
    pre_joining: "vlq-badge tone-review",
    onboarding: "vlq-badge tone-info",
    active: "vlq-badge tone-approved",
    probation: "vlq-badge tone-warning",
    confirmed: "vlq-badge tone-approved",
    review: "vlq-badge tone-review",
    inactive: "vlq-badge tone-muted",
    exit: "vlq-badge tone-danger",
    exited: "vlq-badge tone-danger",
    high: "vlq-badge tone-danger",
    medium: "vlq-badge tone-gold",
    low: "vlq-badge tone-approved",
  };

  return map[normalized] || "vlq-badge tone-muted";
};

export const calculatePayrollTotals = (lineItems = []) => {
  const normalizedItems = lineItems.map((item) => ({
    base_salary: Number(item.base_salary || 0),
    incentives: Number(item.incentives || 0),
    additions: Number(item.additions || 0),
    deductions: Number(item.deductions || 0),
  }));

  const gross = normalizedItems.reduce(
    (sum, item) => sum + item.base_salary + item.incentives + item.additions,
    0,
  );
  const deductions = normalizedItems.reduce((sum, item) => sum + item.deductions, 0);
  const net = gross - deductions;

  return {
    gross,
    deductions,
    net,
    headcount: lineItems.length,
  };
};
